const mutations = {

}

export default mutations